export default "__VITE_ASSET__RdGZ6apx__"